__turbopack_context__.v({
  "listingVerifications": "listing-verifications-module-scss-module__bRFSRa__listingVerifications",
  "listingVerifications__isProfilePage": "listing-verifications-module-scss-module__bRFSRa__listingVerifications__isProfilePage",
  "listingVerifications__withoutText": "listing-verifications-module-scss-module__bRFSRa__listingVerifications__withoutText",
  "listingVerifications_checked": "listing-verifications-module-scss-module__bRFSRa__listingVerifications_checked",
  "listingVerifications_icon": "listing-verifications-module-scss-module__bRFSRa__listingVerifications_icon",
  "listingVerifications_item": "listing-verifications-module-scss-module__bRFSRa__listingVerifications_item",
  "listingVerifications_status": "listing-verifications-module-scss-module__bRFSRa__listingVerifications_status",
  "listingVerifications_text": "listing-verifications-module-scss-module__bRFSRa__listingVerifications_text",
});
